// ...existing code... (update all emerald to auburn)
import React from 'react'
import { Heart, Clock, Users, Award, CheckCircle, Briefcase } from 'lucide-react'

const Careers = () => {
  const benefits = [
    {
      icon: Clock,
      title: 'Flexible Schedules',
      description: 'Work hours that fit your lifestyle with full-time and part-time opportunities',
    },
    {
      icon: Heart,
      title: 'Meaningful Work',
      description: 'Make a real difference in people\'s lives every single day',
    },
    {
      icon: Users,
      title: 'Supportive Team',
      description: 'Join a caring team that values collaboration and mutual support',
    },
    {
      icon: Award,
      title: 'Professional Growth',
      description: 'Ongoing training and development opportunities to advance your career',
    },
  ]

  const qualifications = [
    'Compassionate and patient personality',
    'Reliable transportation',
    'Ability to pass background check',
    'Previous caregiving experience preferred (but not required)',
    'Strong communication skills',
    'Physical ability to assist with mobility and daily tasks',
  ]

  return (
    <div className="min-h-screen" data-component-path="client/src/pages/Careers.jsx" data-component-line="1:1" data-component-id="client/src/pages/Careers.jsx:1:1">
      <section className="bg-gradient-to-br from-auburn-50 via-white to-stone-50 py-20" data-component-path="client/src/pages/Careers.jsx" data-component-line="3:3" data-component-id="client/src/pages/Careers.jsx:3:3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Careers.jsx" data-component-line="4:4" data-component-id="client/src/pages/Careers.jsx:4:4">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-component-path="client/src/pages/Careers.jsx" data-component-line="5:5" data-component-id="client/src/pages/Careers.jsx:5:5">
            <div className="flex flex-col gap-6" data-component-path="client/src/pages/Careers.jsx" data-component-line="6:6" data-component-id="client/src/pages/Careers.jsx:6:6">
              <div className="inline-flex items-center gap-2 bg-auburn-100 text-auburn-700 px-4 py-2 rounded-full w-fit font-semibold" data-component-path="client/src/pages/Careers.jsx" data-component-line="7:7" data-component-id="client/src/pages/Careers.jsx:7:7">
                <Briefcase className="w-5 h-5 flex-shrink-0" data-component-path="client/src/pages/Careers.jsx" data-component-line="8:8" data-component-id="client/src/pages/Careers.jsx:8:8" />
                Now Hiring Caregivers
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900" data-component-path="client/src/pages/Careers.jsx" data-component-line="11:11" data-component-id="client/src/pages/Careers.jsx:11:11">
                Join Our Compassionate Care Team
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed" data-component-path="client/src/pages/Careers.jsx" data-component-line="14:14" data-component-id="client/src/pages/Careers.jsx:14:14">
                Are you passionate about helping others? Do you want to make a meaningful difference in people's lives? Join Refuge Community Outreach and become part of a team that truly cares.
              </p>
              <a
                href="mailto:service@refugecommunityoutreach.org?subject=Caregiver Application"
                className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-auburn-600 text-white rounded-lg hover:bg-auburn-700 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-auburn-300/50 text-lg font-semibold w-fit"
                data-component-path="client/src/pages/Careers.jsx"
                data-component-line="18:18"
                data-component-id="client/src/pages/Careers.jsx:18:18"
              >
                Apply Now
              </a>
            </div>
            <div data-component-path="client/src/pages/Careers.jsx" data-component-line="24:24" data-component-id="client/src/pages/Careers.jsx:24:24">
              <img
                src="https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Elderly woman receiving compassionate care at home"
                className="rounded-2xl shadow-xl w-full h-[500px] object-cover"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/7551586/pexels-photo-7551586.jpeg?auto=compress&cs=tinysrgb&w=1200'
                }}
                data-component-path="client/src/pages/Careers.jsx"
                data-component-line="25:25"
                data-component-id="client/src/pages/Careers.jsx:25:25"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-component-path="client/src/pages/Careers.jsx" data-component-line="40:40" data-component-id="client/src/pages/Careers.jsx:40:40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Careers.jsx" data-component-line="41:41" data-component-id="client/src/pages/Careers.jsx:41:41">
          <div className="text-center mb-16" data-component-path="client/src/pages/Careers.jsx" data-component-line="42:42" data-component-id="client/src/pages/Careers.jsx:42:42">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Careers.jsx" data-component-line="43:43" data-component-id="client/src/pages/Careers.jsx:43:43">Why Work With Us</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/Careers.jsx" data-component-line="44:44" data-component-id="client/src/pages/Careers.jsx:44:44">
              We value our caregivers and provide a supportive environment where you can thrive
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-component-path="client/src/pages/Careers.jsx" data-component-line="48:48" data-component-id="client/src/pages/Careers.jsx:48:48">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-stone-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-200 border border-gray-200"
                data-component-path="client/src/pages/Careers.jsx"
                data-component-line="49:49"
                data-component-id="client/src/pages/Careers.jsx:49:49"
              >
                <div className="flex flex-col gap-4" data-component-path="client/src/pages/Careers.jsx" data-component-line="54:54" data-component-id="client/src/pages/Careers.jsx:54:54">
                  <div className="w-12 h-12 bg-auburn-100 rounded-lg flex items-center justify-center flex-shrink-0" data-component-path="client/src/pages/Careers.jsx" data-component-line="55:55" data-component-id="client/src/pages/Careers.jsx:55:55">
                    <benefit.icon className="w-6 h-6 text-auburn-600" data-component-path="client/src/pages/Careers.jsx" data-component-line="56:56" data-component-id="client/src/pages/Careers.jsx:56:56" />
                  </div>
                  <div data-component-path="client/src/pages/Careers.jsx" data-component-line="58:58" data-component-id="client/src/pages/Careers.jsx:58:58">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-component-path="client/src/pages/Careers.jsx" data-component-line="59:59" data-component-id="client/src/pages/Careers.jsx:59:59">{benefit.title}</h3>
                    <p className="text-gray-600 leading-relaxed" data-component-path="client/src/pages/Careers.jsx" data-component-line="60:60" data-component-id="client/src/pages/Careers.jsx:60:60">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-stone-50" data-component-path="client/src/pages/Careers.jsx" data-component-line="70:70" data-component-id="client/src/pages/Careers.jsx:70:70">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/Careers.jsx" data-component-line="71:71" data-component-id="client/src/pages/Careers.jsx:71:71">
          <div className="text-center mb-12" data-component-path="client/src/pages/Careers.jsx" data-component-line="72:72" data-component-id="client/src/pages/Careers.jsx:72:72">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-component-path="client/src/pages/Careers.jsx" data-component-line="73:73" data-component-id="client/src/pages/Careers.jsx:73:73">What We're Looking For</h2>
            <p className="text-xl text-gray-600" data-component-path="client/src/pages/Careers.jsx" data-component-line="74:74" data-component-id="client/src/pages/Careers.jsx:74:74">
              We welcome caregivers with diverse backgrounds and experience levels
            </p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200" data-component-path="client/src/pages/Careers.jsx" data-component-line="78:78" data-component-id="client/src/pages/Careers.jsx:78:78">
            <div className="grid md:grid-cols-2 gap-4" data-component-path="client/src/pages/Careers.jsx" data-component-line="79:79" data-component-id="client/src/pages/Careers.jsx:79:79">
              {qualifications.map((qualification, index) => (
                <div key={index} className="flex items-start gap-3" data-component-path="client/src/pages/Careers.jsx" data-component-line="80:80" data-component-id="client/src/pages/Careers.jsx:80:80">
                  <CheckCircle className="w-6 h-6 text-auburn-600 flex-shrink-0 mt-0.5" data-component-path="client/src/pages/Careers.jsx" data-component-line="81:81" data-component-id="client/src/pages/Careers.jsx:81:81" />
                  <span className="text-gray-700" data-component-path="client/src/pages/Careers.jsx" data-component-line="82:82" data-component-id="client/src/pages/Careers.jsx:82:82">{qualification}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-auburn-600" data-component-path="client/src/pages/Careers.jsx" data-component-line="91:91" data-component-id="client/src/pages/Careers.jsx:91:91">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/Careers.jsx" data-component-line="92:92" data-component-id="client/src/pages/Careers.jsx:92:92">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-component-path="client/src/pages/Careers.jsx" data-component-line="93:93" data-component-id="client/src/pages/Careers.jsx:93:93">
            Ready to Make a Difference?
          </h2>
          <p className="text-xl text-auburn-50 leading-relaxed mb-8" data-component-path="client/src/pages/Careers.jsx" data-component-line="96:96" data-component-id="client/src/pages/Careers.jsx:96:96">
            Join our team of dedicated caregivers and start a rewarding career helping others live with dignity and independence. We provide the training and support you need to succeed.
          </p>
          <a
            href="mailto:service@refugecommunityoutreach.org?subject=Caregiver Application"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 bg-white text-auburn-600 rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-white/50 text-lg font-semibold"
            data-component-path="client/src/pages/Careers.jsx"
            data-component-line="100:100"
            data-component-id="client/src/pages/Careers.jsx:100:100"
          >
            Apply Today
          </a>
        </div>
      </section>
    </div>
  )
}

export default Careers